// extracted by mini-css-extract-plugin
export default {"tcWrapper":"talent-calculator_tcWrapper__yQlU8"};